import { request } from '../../request';
import confs from '../../configurations';

const { URL_API } = confs;

export const auth = {
    login: (credentials) => request.post(URL_API+'/users/login', credentials),
    forgotPassword: (code) => request.post(URL_API+'/users/forgot-password/'+ code),
    resetPassword: (data) => request.post(URL_API+'/users/reset-password', data),
    confirm: () => request.get(URL_API+'/users/confirm'),
}